import { Component, OnInit } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxSpinnerService } from 'ngx-spinner';
import { HomeAllRequestService } from '../../service/home-all-request.service';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-modal-terms',
  templateUrl: './modal-terms.component.html',
  styleUrls: ['./modal-terms.component.css']
})
export class ModalTermsComponent implements OnInit {
  id: any;
  hasAgreeed: any;
   bodyTranslation: string;
   selectLang: string;
  constructor( public dialogRef: MatDialogRef<ModalTermsComponent>,
               private dataApi: HomeAllRequestService,
               public dialog: MatDialog,
               private dateAdapter: DateAdapter<Date> ,
               private spinner: NgxSpinnerService,
               private _snackBar: MatSnackBar,
              public translate: TranslateService) {
                translate.addLangs(['en', 'es']);
                if(sessionStorage.lang === undefined || sessionStorage.lang == null){
                  translate.setDefaultLang('en');
                  this.selectLang='en';
                  this.dateAdapter.setLocale('en');
                  sessionStorage.setItem('lang', 'en');

                } else {
                  this.selectLang = String(sessionStorage.lang);
                  this.dateAdapter.setLocale(sessionStorage.lang);
                  this.spinner.show("translate")
                  translate.use(String(sessionStorage.lang)).subscribe( (response)=>{this.spinner.hide("translate")}, ()=>{this.spinner.hide("translate")});
                }

                }

  Terms()
  {
    this.dataApi.getTerms()
      .subscribe((data: any) => {
        this.id = data.mdmid,
        this.hasAgreeed = data.hasAgreeed;
      });
  }

  Accept(){
    this.spinner.show("loading");
    this.dataApi.acceptTerms(this.id).subscribe(() => {
      this.spinner.hide("loading");
      //this.router.navigate(['/incoming-access-confirmation/'+this.id])
    },() => {
      this.spinner.hide("loading");
    });
    this.dialogRef.close(true);
  }
  Close(){
    this.dialogRef.close(false);
  }
  ngOnInit() {
     this.translate.get('terms-conditions.login-general').subscribe((data: any) => {
       if (!(data === null || data === undefined)) {
         this.bodyTranslation = data.split('\n');
       }
     });

     setTimeout( ()=> {}, 1000);
    this.Terms();
  }
  updateLang(lang) {
    sessionStorage.setItem('lang', lang);
    this.selectLang = lang;
    this.dateAdapter.setLocale(String(lang));

    this.spinner.show("translate")
    this.translate.use(String(lang)).subscribe(
      (response)=>{
        this.spinner.hide("translate")
      }
      ,
      ()=>{
        this.spinner.hide("translate")
      });

  }

}
